import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, CheckCircle2 } from 'lucide-react';
const names = ['Juan', 'María', 'Carlos', 'Luciana', 'Facundo', 'Sofía', 'Diego', 'Valentina', 'Javier', 'Camila'];
const cities = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  const [timeAgo, setTimeAgo] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setTimeAgo(`hace ${randomTime} min`);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring interval
    const intervalTimer = setInterval(showPopup, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-92">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-white rounded-lg shadow-2xl p-4 border-l-4 border-brand-green max-w-[300px] flex items-start gap-3" data-id="element-93">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-94">
            <CheckCircle2 className="w-5 h-5 text-brand-green" data-id="element-95" />
          </div>
          <div data-id="element-96">
            <p className="text-sm text-gray-800 font-body" data-id="element-97">
              <span className="font-bold" data-id="element-98">{currentName}</span> de {currentCity}{' '}
              acaba de comprar <strong data-id="element-99">Kit Inmobiliario PRO</strong>
            </p>
            <div className="flex items-center gap-1 mt-1 text-xs text-gray-500" data-id="element-100">
              <MapPin className="w-3 h-3" data-id="element-101" />
              <span data-id="element-102">{timeAgo}</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}